import { Token } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
const { either, map } = Parser;
/**
 * {@link https://drafts.csswg.org/mediaqueries-5/#mq-prefix}
 *
 * @public
 */
export var Modifier;
(function (Modifier) {
    Modifier["Only"] = "only";
    Modifier["Not"] = "not";
})(Modifier || (Modifier = {}));
/**
 * @public
 */
(function (Modifier) {
    Modifier.parse = either(map(Token.parseIdent("only"), () => Modifier.Only), map(Token.parseIdent("not"), () => Modifier.Not));
})(Modifier || (Modifier = {}));
//# sourceMappingURL=modifier.js.map